import { render, staticRenderFns } from "./BlogModal.vue?vue&type=template&id=34d3cd84&"
import script from "./BlogModal.vue?vue&type=script&lang=js&"
export * from "./BlogModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports